import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const LANG_KEY = "melly_lang";

export const S = {
  appName: { de: "MELLY", en: "MELLY" },
  appSub: { de: "LEADERSHIP", en: "LEADERSHIP" },
  getStarted: { de: "Los geht's", en: "Get started" },
  welcomeTagline: { de: "Wissen. Verstehen. Anwenden.", en: "Learn. Understand. Apply." },
  welcomeSub: { de: "Für deine erfolgreiche Zukunft.", en: "For your successful future." },
  continue: { de: "Weiter", en: "Continue" },
  next: { de: "Nächste", en: "Next" },
  back: { de: "Zurück", en: "Back" },
  done: { de: "Fertig", en: "Done" },
  cancel: { de: "Abbrechen", en: "Cancel" },
  save: { de: "Speichern", en: "Save" },
  loading: { de: "Lädt …", en: "Loading …" },
  retry: { de: "Erneut versuchen", en: "Retry" },
  min: { de: "Min", en: "min" },
  correct: { de: "Richtig!", en: "Correct!" },
  incorrect: { de: "Nicht ganz", en: "Not quite" },
  yourAnswer: { de: "Deine Antwort", en: "Your answer" },
  submit: { de: "Antwort prüfen", en: "Check answer" },
  finish: { de: "Abschliessen", en: "Finish" },
  question: { de: "Frage", en: "Question" },
  of: { de: "von", en: "of" },
  signIn: { de: "Anmelden", en: "Sign in" },
  email: { de: "E-Mail", en: "Email" },
  password: { de: "Passwort", en: "Password" },
  signOut: { de: "Abmelden", en: "Sign out" },
  loginFailed: { de: "Anmeldung fehlgeschlagen", en: "Login failed" },
  loginHint: { de: "Melde dich mit deinen Zugangsdaten an.", en: "Sign in with your credentials." },
  tabHome: { de: "Home", en: "Home" },
  tabLearn: { de: "Lernen", en: "Learn" },
  tabPractice: { de: "Üben", en: "Practice" },
  tabExams: { de: "Prüfungen", en: "Exams" },
  tabMore: { de: "Mehr", en: "More" },
  goodMorning: { de: "Guten Morgen", en: "Good morning" },
  goodDay: { de: "Schön, dass du da bist", en: "Good to see you" },
  daysToExam: { de: "Tage bis zur Prüfung", en: "days until the exam" },
  setExamDate: { de: "Prüfungsdatum festlegen", en: "Set exam date" },
  todayForYou: { de: "Heute für dich", en: "Today for you" },
  startTraining: { de: "Heutiges Training starten", en: "Start today's training" },
  yourProgress: { de: "Dein Fortschritt", en: "Your progress" },
  examReadiness: { de: "Prüfungsbereitschaft", en: "Exam readiness" },
  reviewMotivation: { de: "Motivation wiederholen", en: "Review motivation" },
  solveCase: { de: "Real Case lösen", en: "Solve a real case" },
  examQuestions: { de: "Prüfungsfragen", en: "exam questions" },
  allDoneToday: { de: "Alles erledigt für heute. Stark, {name}!", en: "All done for today. Great work, {name}!" },
  modules: { de: "Module", en: "Modules" },
  lessons: { de: "Lektionen", en: "Lessons" },
  lesson: { de: "Lektion", en: "Lesson" },
  learnAll: { de: "Alle", en: "All" },
  tLearn: { de: "Lernen", en: "Learn" },
  tKey: { de: "Key Points", en: "Key Points" },
  tExample: { de: "Beispiel", en: "Example" },
  tQuiz: { de: "Quiz", en: "Quiz" },
  objective: { de: "Lernziel", en: "Learning objective" },
  explained: { de: "Kurz erklärt", en: "Explained simply" },
  whyMatters: { de: "Warum ist das wichtig?", en: "Why does it matter?" },
  remember: { de: "Merke dir", en: "Remember" },
  commonMistake: { de: "Typischer Fehler", en: "Common mistake" },
  applyIt: { de: "Wende es an", en: "Apply it" },
  miniCheck: { de: "Mini-Check", en: "Mini check" },
  toQuiz: { de: "Weiter zum Mini-Check", en: "Continue to mini check" },
  lessonComplete: { de: "Lektion abgeschlossen", en: "Lesson complete" },
  markComplete: { de: "Als erledigt markieren", en: "Mark as complete" },
  completed: { de: "Abgeschlossen", en: "Completed" },
  practice: { de: "Üben", en: "Practice" },
  dailyReview: { de: "Daily Review", en: "Daily Review" },
  dailyReviewDesc: { de: "Deine persönliche Tagessession", en: "Your personalised daily session" },
  flashcards: { de: "Flashcards", en: "Flashcards" },
  flashcardsDesc: { de: "Wissen, Verstehen, Anwenden", en: "Know, understand, apply" },
  quickQuiz: { de: "Quick Quiz", en: "Quick Quiz" },
  quickQuizDesc: { de: "5 gemischte Fragen", en: "5 mixed questions" },
  practiceQuiz: { de: "Practice Quiz", en: "Practice Quiz" },
  realCases: { de: "Real Cases", en: "Real Cases" },
  realCasesDesc: { de: "Praxisnahe Führungsfälle", en: "Realistic leadership cases" },
  scenarioChallenge: { de: "Scenario Challenge", en: "Scenario Challenge" },
  scenarioDesc: { de: "Entscheidungen mit Folgen", en: "Decisions with consequences" },
  spotMistake: { de: "Spot the Mistake", en: "Spot the Mistake" },
  spotDesc: { de: "Finde den Führungsfehler", en: "Find the leadership mistake" },
  matchIt: { de: "Match It", en: "Match It" },
  matchDesc: { de: "Begriffe zuordnen", en: "Match the concepts" },
  orderIt: { de: "Order It", en: "Order It" },
  orderDesc: { de: "Schritte richtig sortieren", en: "Sort the steps correctly" },
  trueFalse: { de: "True / False", en: "True / False" },
  trueFalseDesc: { de: "Aussagen bewerten", en: "Judge the statements" },
  myMistakes: { de: "Meine Fehler", en: "My Mistakes" },
  myMistakesDesc: { de: "Fehler gezielt trainieren", en: "Train your mistakes" },
  weakTopics: { de: "Schwache Themen", en: "Weak Topics" },
  weakTopicsDesc: { de: "Empfohlene Schwerpunkte", en: "Recommended focus areas" },
  showAnswer: { de: "Antwort anzeigen", en: "Show answer" },
  knewIt: { de: "Wusste ich", en: "I knew it" },
  practiceAgain: { de: "Noch üben", en: "Practice again" },
  noCardsDue: { de: "Keine Karten fällig – super!", en: "No cards due – great!" },
  cardKnow: { de: "Wissen", en: "Know it" },
  cardUnderstand: { de: "Verstehen", en: "Understand it" },
  cardApply: { de: "Anwenden", en: "Apply it" },
  tapInOrder: { de: "Tippe die Schritte in der richtigen Reihenfolge an.", en: "Tap the steps in the correct order." },
  checkOrder: { de: "Reihenfolge prüfen", en: "Check order" },
  matchPrompt: { de: "Wähle links, dann die passende Zuordnung rechts.", en: "Pick left, then the matching item on the right." },
  exams: { de: "Prüfungen", en: "Exams" },
  quickTest: { de: "Quick Test", en: "Quick Test" },
  moduleExams: { de: "Modul-Prüfungen", en: "Module Exams" },
  mixedExam: { de: "Mixed Exam", en: "Mixed Exam" },
  mockExams: { de: "Mock Exams", en: "Mock Exams" },
  examHistory: { de: "Prüfungsverlauf", en: "Exam History" },
  startExam: { de: "Prüfung starten", en: "Start exam" },
  noExamsYet: { de: "Noch keine Prüfungen absolviert.", en: "No exams taken yet." },
  examResult: { de: "Ergebnis", en: "Result" },
  score: { de: "Punkte", en: "Score" },
  passed: { de: "Bestanden", en: "Passed" },
  failed: { de: "Nicht bestanden", en: "Not passed" },
  reviewAnswers: { de: "Antworten ansehen", en: "Review answers" },
  correctAnswer: { de: "Richtige Antwort", en: "Correct answer" },
  notAnswered: { de: "Nicht beantwortet", en: "Not answered" },
  examReview: { de: "Prüfung ansehen", en: "Exam review" },
  questions: { de: "Fragen", en: "questions" },
  overview: { de: "Übersicht", en: "Overview" },
  topics: { de: "Themen", en: "Topics" },
  strengths: { de: "Stärken & Schwächen", en: "Strengths & Weaknesses" },
  questionsAnswered: { de: "Fragen beantwortet", en: "Questions answered" },
  accuracy: { de: "Trefferquote", en: "Accuracy" },
  lessonsDone: { de: "Lektionen abgeschlossen", en: "Lessons completed" },
  streak: { de: "Tage Streak", en: "day streak" },
  cardsMastered: { de: "Karten gemeistert", en: "cards mastered" },
  studyTime: { de: "Lernzeit", en: "Study time" },
  notes: { de: "Meine Notizen", en: "My Notes" },
  bookmarks: { de: "Lesezeichen", en: "Bookmarks" },
  settings: { de: "Einstellungen", en: "Settings" },
  language: { de: "Sprache", en: "Language" },
  learner: { de: "Leadership Learner", en: "Leadership Learner" },
  motto: { de: "„Bessere Führung beginnt bei mir.“", en: '"Better leadership begins with me."' },
  editProfile: { de: "Profil bearbeiten", en: "Edit profile" },
  displayName: { de: "Anzeigename", en: "Display name" },
  chooseAvatar: { de: "Profilbild wählen", en: "Choose profile picture" },
  mottoLabel: { de: "Dein Motto", en: "Your motto" },
  saved: { de: "Gespeichert", en: "Saved" },
  learnerDetail: { de: "Lernübersicht", en: "Learner overview" },
  topicMastery: { de: "Themen-Beherrschung", en: "Topic mastery" },
  youGotThis: { de: "Du schaffst das.", en: "You've got this." },
  youGotThisSub: { de: "Disziplin heute. Erfolg morgen.", en: "Discipline today. Success tomorrow." },
  strong: { de: "Sehr stark", en: "Strong" },
  improve: { de: "Verbessern", en: "Needs improvement" },
  critical: { de: "Kritisch", en: "Critical" },
  noMistakes: { de: "Keine offenen Fehler – top!", en: "No open mistakes – great!" },
  addNote: { de: "Notiz hinzufügen", en: "Add note" },
  noNotes: { de: "Noch keine Notizen.", en: "No notes yet." },
  noBookmarks: { de: "Noch keine Lesezeichen.", en: "No bookmarks yet." },
  errors: { de: "Fehler", en: "mistakes" },
  practiceMistakes: { de: "Fehler trainieren", en: "Practice mistakes" },
  admin: { de: "Admin", en: "Admin" },
  adminPanel: { de: "Admin-Panel", en: "Admin Panel" },
  users: { de: "Nutzer", en: "Users" },
  results: { de: "Ergebnisse", en: "Results" },
  createUser: { de: "Nutzer erstellen", en: "Create user" },
  name: { de: "Name", en: "Name" },
  role: { de: "Rolle", en: "Role" },
  noUsers: { de: "Noch keine Lernenden.", en: "No learners yet." },
  deactivate: { de: "Deaktivieren", en: "Deactivate" },
  examDateTitle: { de: "Wann ist deine Prüfung?", en: "When is your exam?" },
  examDateHint: { de: "Wir passen deinen Lernplan automatisch an.", en: "We adapt your study plan automatically." },
};

export function fmt(str, vars) {
  return Object.entries(vars).reduce((s, [k, v]) => s.replace(`{${k}}`, v), str);
}

const Ctx = createContext({ lang: "de", setLang: () => {}, tr: (k) => String(k), ready: false });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState("de");
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const saved = localStorage.getItem(LANG_KEY);
    if (saved === "de" || saved === "en") setLangState(saved);
    setReady(true);
  }, []);
  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem(LANG_KEY, l);
  }, []);
  const tr = useCallback((key) => (S[key] ? S[key][lang] : String(key)), [lang]);
  return <Ctx.Provider value={{ lang, setLang, tr, ready }}>{children}</Ctx.Provider>;
}

export const useI18n = () => useContext(Ctx);
